<template>
  <div
    class="asset-card-wrapper"
    :class="{ 'asset-card-wrapper-field-height': asset.field }"
    :data-qa="`asset-card-${asset.label}`"
  >
    <div v-if="asset.field" class="assets-field-wrapper">
      <p>{{ $t('Gamification_Assets_File') }}: {{ asset.field }}</p>
    </div>
    <div class="asset-card-content" data-qa="asset-card-content">
      <div
        v-if="asset.value"
        class="asset-card-img-wrapper"
        data-qa="asset-card-img-wrapper"
      >
        <div
          v-if="type === GameAssetsTemplateEnum.FONTS"
          class="font-preview"
          :style="{ fontFamily: dynamicFontName }"
          data-qa="asset-font-preview"
        >
          Lorem ipsum dolor sit amet
        </div>
        <img
          v-else
          :src="asset.value"
          :alt="`asset-${asset.label}`"
          data-qa="asset-image"
        />

        <div class="overlay-buttons" data-qa="asset-overlay-buttons">
          <icon
            glyph="download"
            class="overlay-button"
            @click="downloadAsset(asset)"
            data-qa="download-asset-btn"
          />
          <icon
            glyph="bin"
            class="overlay-button"
            @click="deleteAsset(asset)"
            data-qa="delete-asset-btn"
            v-if="!isReadOnly"
          />
        </div>
      </div>
      <icon
        v-else
        glyph="image-placeholder"
        class="image-placeholder-icon"
        data-qa="asset-placeholder-icon"
      />
    </div>
    <div class="asset-card-footer" data-qa="asset-card-footer">
      <p class="asset-card-footer-text" data-qa="asset-label">
        {{ asset.label }}
      </p>
    </div>
    <el-dialog
      :visible="deleteInProgress"
      center
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="delete-dialog">
        <img src="/img/frameloader.gif" width="48" />
        <div>
          <h2>{{ $t('Gamification_Assets_Delete_Asset') }}</h2>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { GameAssetsTemplateEnum } from '@/modules/gamification/enum/GameAssetsTemplateEnum'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'GameAssetsCard',
  props: {
    asset: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    gameCampaignId: {
      type: Number
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      GameAssetsTemplateEnum,
      dynamicFontName: '',
      deleteInProgress: false
    }
  },
  mounted() {
    if (this.type === GameAssetsTemplateEnum.FONTS && this.asset.value) {
      this.loadFont(this.asset.label, this.asset.value)
    }
  },
  methods: {
    loadFont(name, url) {
      const fontName = `font_${name.replace(/\s+/g, '_')}`

      if (!document.getElementById(fontName)) {
        const style = document.createElement('style')
        style.id = fontName
        style.innerHTML = `
          @font-face {
            font-family: '${fontName}';
            src: url('${url}');
          }
        `
        document.head.appendChild(style)
      }

      this.dynamicFontName = fontName
    },
    downloadAsset(asset) {
      if (!asset.value) {
        this.$message({
          message: this.$t('Gamification_Assets_Download_Failed'),
          type: 'error'
        })
        return
      }
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/download-asset`,
          params: {
            objectUrl: asset.value
          },
          responseType: 'blob'
        })
      )
        .then(({ data }) => {
          const url = window.URL.createObjectURL(data)
          const link = document.createElement('a')
          let fileName = asset.value.split('/').pop()
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    deleteAsset(asset) {
      if (!asset.value && !asset.id) {
        this.$message({
          message: this.$t('Gamification_Assets_Delete_Asset_Fail'),
          type: 'error'
        })
        return
      }
      this.deleteInProgress = true
      RestApi(
        projectEndpoint({
          method: 'delete',
          url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/asset/${asset.id}`,
          params: {
            objectUrl: asset.value
          }
        })
      )
        .then(() => {
          this.$message({
            message: this.$t('RestList_DeleteSuccessMessage'),
            type: 'success'
          })
          this.$emit('after-delete')
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.deleteInProgress = false
        })
    }
  }
}
</script>
<style scoped>
.asset-card-wrapper {
  border: 1px solid #dbdee7;
  border-radius: 4px;
  width: 200px;
  height: 228px;
  display: flex;
  flex-direction: column;
}
.asset-card-content {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 170px;
  background-color: #f7f7f7;
}
.asset-card-img-wrapper {
  width: 100%;
  height: 100%;
  padding: 24px 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
}
.asset-card-img-wrapper img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  transition: filter 0.3s ease, transform 0.3s ease;
}
.overlay-buttons {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  gap: 10px;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.overlay-button {
  color: #1d87c9;
  border: 1px solid #1d87c9;
  border-radius: 4px;
  background-color: #fff;
  font-size: 20px;
  padding: 8px;
}
.overlay-button:hover {
  background-color: #1d87c9;
  color: #fff;
  cursor: pointer;
}
.asset-card-img-wrapper:hover img,
.asset-card-img-wrapper:hover .font-preview {
  filter: blur(8.9px);
}
.asset-card-img-wrapper:hover .overlay-buttons {
  opacity: 1;
}
.asset-card-footer {
  border-top: 1px solid #dbdee7;
  background-color: #e5f2fb;
  flex-shrink: 0;
  height: 48px;
  padding: 3px 0px;
  display: flex;
  align-items: center;
}
.asset-card-footer-text {
  font-size: 14px;
  line-height: 14px;
  color: #4b515f;
  padding: 14px 8px;
}
.image-placeholder-icon {
  color: #4b515f;
  font-size: 18px;
}
.font-preview {
  font-size: 18px;
  text-align: center;
}
.delete-dialog {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
}
.assets-field-wrapper {
  color: #4b515f;
  font-size: 14px;
  line-height: 14px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.asset-card-wrapper-field-height {
  height: 262px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/content-assets/GameAssetsCard.vue